import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useContextMenuStore = defineStore('contextMenu', () => {
  const showContextMenu = ref(false);
  const menuX = ref(0);
  const menuY = ref(0);
  const linkUrl = ref('');
  const onShowContextMenu = (event: MouseEvent, url: string) => {
    event.preventDefault();
    const target = event.target as HTMLDivElement;
    const ssLinkEle = target.closest('.ss-link');
    if (ssLinkEle) {
      menuX.value = event.clientX;
      menuY.value = event.clientY;
      const unique_id = ssLinkEle.getAttribute('id');
      if (unique_id) {
        linkUrl.value = location.origin + url.replace('{unique_id}', unique_id);
        showContextMenu.value = true;
      }
    }
  };

  const onCloseContextMenu = () => {
    showContextMenu.value = false;
  };

  return {
    showContextMenu,
    menuX,
    menuY,
    linkUrl,

    onShowContextMenu,
    onCloseContextMenu,
  };
});
